import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { digitalApi as api } from './api';
import { useAuth } from '../../context/AuthContext';
import { C } from '../../theme';

function Modal({ title, onClose, children }) {
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(80,120,160,0.25)', backdropFilter:'blur(4px)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }} onClick={onClose}>
      <div style={C.modal} onClick={e=>e.stopPropagation()}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:22 }}>
          <h2 style={{ margin:0, fontSize:16, fontWeight:800, color:'#1a2a3a' }}>{title}</h2>
          <button onClick={onClose} style={{ background:'none', border:'none', color:'#8aa0b8', fontSize:22, cursor:'pointer' }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export default function BrandsPage() {
  const { canEdit, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ name: '' });
  const [saving, setSaving] = useState(false);
  const [search, setSearch] = useState('');

  const load = () => api.getBrands().then(setBrands).catch(()=>{}).finally(()=>setLoading(false));
  useEffect(() => { load(); }, []);

  async function handleSave() {
    if (!form.name.trim()) return;
    setSaving(true);
    try {
      if (modal === 'new') await api.createBrand({ name: form.name });
      else await api.updateBrand(modal.id, { name: form.name });
      await load(); setModal(null);
    } catch(e) { alert(e.message); } finally { setSaving(false); }
  }

  async function handleDelete(e, id) {
    e.stopPropagation();
    if (!window.confirm('Delete this brand?')) return;
    await api.deleteBrand(id); load();
  }

  const filtered = brands.filter(b =>
    b.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={C.page}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:28 }}>
        <h1 style={C.title}>Brands <span style={{ color:'#8aa0b8', fontWeight:400, fontSize:16 }}>({brands.length})</span></h1>
        <div style={{ display:'flex', gap:10, alignItems:'center' }}>
          <input placeholder="Search…" value={search} onChange={e=>setSearch(e.target.value)}
            style={{ padding:'8px 14px', border:'1px solid #c8d8e8', borderRadius:8, fontSize:13, outline:'none', width:200, background:'rgba(255,255,255,0.7)' }}/>
          {canEdit && <button style={C.btnPrimary} onClick={()=>{ setForm({ name:'' }); setModal('new'); }}>+ New Brand</button>}
        </div>
      </div>

      {loading ? <div style={C.empty}>Loading…</div> : (
        <table style={C.table}>
          <thead>
            <tr>
              <th style={C.th}>Brand</th>
              <th style={C.th}>Plans</th>
              <th style={C.th}>Added</th>
              <th style={C.th}></th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={4} style={{...C.td, textAlign:'center', color:'#8aa0b8', padding:48}}>
                {search ? 'No brands match.' : 'No brands yet. Create your first brand.'}
              </td></tr>
            ) : filtered.map(b => (
              <tr key={b.id} style={C.tr} onClick={()=>navigate(`/brands/${b.id}`)}
                onMouseEnter={e=>e.currentTarget.style.background='rgba(0,144,208,0.04)'}
                onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                <td style={{...C.td, fontWeight:700}}>{b.name}</td>
                <td style={{...C.td, color:'#6a8aaa'}}>{b.plan_count||0} {b.plan_count===1?'plan':'plans'}</td>
                <td style={{...C.td, color:'#6a8aaa'}}>
                  {b.created_at ? new Date(b.created_at).toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'}) : '—'}
                </td>
                <td style={{...C.td, textAlign:'right', whiteSpace:'nowrap'}} onClick={e=>e.stopPropagation()}>
                  {canEdit && <button style={C.btnSecondary} onClick={e=>{ e.stopPropagation(); setForm({ name:b.name }); setModal(b); }}>Edit</button>}
                  {isAdmin && b.plan_count===0 && <button style={C.btnDanger} onClick={e=>handleDelete(e,b.id)}>Delete</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {modal && (
        <Modal title={modal==='new' ? 'New Brand' : `Edit: ${modal.name}`} onClose={()=>setModal(null)}>
          <label style={{ display:'block', marginBottom:22 }}>
            <span style={C.label}>Brand Name *</span>
            <input value={form.name} onChange={e=>setForm(p=>({...p, name:e.target.value}))} placeholder="e.g. Acme Brand" style={C.input} autoFocus/>
          </label>
          <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
            <button style={C.btnSecondary} onClick={()=>setModal(null)}>Cancel</button>
            <button style={C.btnPrimary} onClick={handleSave} disabled={saving}>{saving ? 'Saving…' : modal==='new' ? 'Create Brand' : 'Save'}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
